import React, {useEffect} from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import "./styles-mobile.scss";
import Alerte from "../../Chat/shared/Alerte/Alerte";
import error from "../../../assets/icons/error.svg";
import back from "../../../assets/icons/backBis.svg";
import Input from "../../Chat/shared/Input/Input";
import SpecialGoogleInput from "../../Chat/shared/Input/SpecialGoogleInput";

const OfferForm = ({
                       setLastnameStripeInfos,
                       setFirstnameStripeInfos,
                       setAddressStripeInfos,
                       setCityStripeInfos,
                       setPostalCodeStripeInfos,
                       createCustomer,
                       offerPrice,
                       checkPromotionCode,
                       promotionCode,
                       promotionCodeFlag,
                       errorMessage,
                       setOfferPrice,
                       customerId,
                       updateCustomer,
                       setTelStripeInfos,
                       activationCodeFlag,
                       setUserInfos,
                       step,
                       setStep,
                       resetUserInfos,
                       userInfos
                   }) => {

    useEffect(() => {
        if (step === "offer-49") {
            setOfferPrice(49);
        }
        if (step === "offer-190") {
            setOfferPrice(190);
        }
        if (step === "offer-350") {
            setOfferPrice(350);
        }
        if (step === "offer-589") {
            setOfferPrice(589);
        }
        if (step === "offer-390") {
            setOfferPrice(390);
        }
    }, [promotionCodeFlag, activationCodeFlag, offerPrice]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (promotionCode) {
            await checkPromotionCode();
        } else {
            if (offerPrice == 390) {
                setStep("checkout-390");
            } else if (offerPrice == 49) {
                setStep("checkout-49");
            } else if (offerPrice == 190) {
                setStep("checkout-190");
            } else if (offerPrice == 589) {
                setStep("checkout-589");
            } else if (offerPrice == 350) {
                setStep("checkout-350");
            }
            if (!resetUserInfos && !customerId) {
                createCustomer();
            } else if (resetUserInfos) {
                updateCustomer();
            }
        }
    };

    return (
        <>
            <>
                <div className="titleModale">
                    {
                        {
                            200:
                                <>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        setStep("offer-choices");
                                    }}><img src={back}/></a>
                                    <h1>Bénéficier d&apos;un accompagnement complet pour un montant de 600€ payable en 3
                                        mensualités de {offerPrice} €</h1>
                                </>,
                            "offer-49":
                                <>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        setStep("offer-choices");
                                    }}><img src={back}/></a>
                                    <h1>Offre49</h1>
                                </>,
                            "offer-190":
                                <>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        setStep("offer-choices");
                                    }}><img src={back}/></a>
                                    <h1>Offre190</h1>
                                </>,
                            "offer-390":
                                <>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        setStep("offer-choices");
                                    }}><img src={back}/></a>
                                    <h1>Situation d&apos;urgence</h1>
                                </>,
                            "offer-589":
                                <>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        setStep("offer-choices");
                                    }}><img src={back}/></a>
                                    <h1>Bénéficiez de 1 an d&apos;accompagnement</h1>
                                </>,
                            "offer-350":
                                <>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        setStep("offer-choices");
                                    }}><img src={back}/></a>
                                    <h1>Bénéficiez de 6 mois d&apos;accompagnement</h1>
                                </>,
                        }[step]
                    }

                </div>
                <h3>Pour poursuivre votre souscription, merci de bien vouloir compléter les informations
                    ci-dessous.</h3>

                <form onSubmit={handleSubmit}>
                    <div className="input-container">
                        <div className="input-spacing">
                            <Input
                                label={"Nom"}
                                type="text"
                                required
                                value={userInfos.lastname}
                                valueToActive={userInfos.lastname}
                                onChange={(e) => {
                                    setUserInfos(e.target.value, "lastname");
                                    setLastnameStripeInfos(e.target.value);
                                }}
                            />
                        </div>
                        <div className="input-spacing">
                            <Input
                                label={"Prénom"}
                                type="text"
                                required
                                value={userInfos.firstname}
                                valueToActive={userInfos.firstname}
                                onChange={(e) => {
                                    setUserInfos(e.target.value, "firstname");
                                    setFirstnameStripeInfos(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    {/*<label htmlFor="">Adresse email*</label>*/}
                    {/*<input type="email" required onChange={(e) => setEmailStripeInfos(e.target.value)}/>*/}
                    <Input
                        label={"Téléphone"}
                        type="tel"
                        required
                        value={userInfos.tel}
                        valueToActive={userInfos.tel}
                        onChange={(e) => {
                            setUserInfos(e.target.value, "tel");
                            setTelStripeInfos(e.target.value);
                        }}
                    />
                    <div className="input-container">
                        <div className="input-spacing-address">
                            <SpecialGoogleInput
                                label={"Adresse"}
                                type="text"
                                required
                                setUserInfos={setUserInfos}
                                setAddressStripeInfos={setAddressStripeInfos}
                                setCityStripeInfos={setCityStripeInfos}
                                setPostalCodeStripeInfos={setPostalCodeStripeInfos}
                                value={userInfos.address}
                                valueToActive={userInfos.address}
                            />
                        </div>
                        <div className="input-spacing-cp">
                            <Input
                                label={"Code postal"}
                                type="text"
                                required
                                value={userInfos.postalCode}
                                valueToActive={userInfos.postalCode}
                                onChange={(e) => {
                                    setUserInfos(e.target.value, "cp");
                                    setPostalCodeStripeInfos(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <Input
                        label={"Ville"}
                        type="text"
                        required
                        value={userInfos.city}
                        valueToActive={userInfos.city}
                        onChange={(e) => {
                            setUserInfos(e.target.value, "city");
                            setCityStripeInfos(e.target.value);
                        }}
                    />
                    {/*<label htmlFor="">Avez vous un code promotionnel ?</label>*/}
                    {/*<input type="text" onChange={(e) => setPromotionCode(e.target.value)}/>*/}
                    <button className="submit-modal">Aller au paiement - Étape 2</button>
                </form>

            </>
            {errorMessage &&
                <Alerte src={error} activeClass={"error"} text={errorMessage}/>
            }
        </>
    );
};

OfferForm.propTypes = {
    setEmailStripeInfos: PropTypes.func,
    setLastnameStripeInfos: PropTypes.func,
    setFirstnameStripeInfos: PropTypes.func,
    setTelStripeInfos: PropTypes.func,
    setAddressStripeInfos: PropTypes.func,
    setCityStripeInfos: PropTypes.func,
    setPostalCodeStripeInfos: PropTypes.func,
    createCustomer: PropTypes.func,
    offerPrice: PropTypes.number,
    setPromotionCode: PropTypes.func,
    checkPromotionCode: PropTypes.func,
    setOfferPrice: PropTypes.func,
    promotionCodeFlag: PropTypes.bool,
    activationCodeFlag: PropTypes.bool,
    promotionCode: PropTypes.string,
    errorMessage: PropTypes.string,
    customerId: PropTypes.string,
    updateCustomer: PropTypes.func,
    setUserInfos: PropTypes.func,
    setStep: PropTypes.func,
    step: PropTypes.string,
    resetUserInfos: PropTypes.string,
    setResetUserInfos: PropTypes.func,
    userInfos: PropTypes.object,
};

export default OfferForm;
 